import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
//import axios from 'axios'
import axios from "axios";
import store from "../store"; // ストアのパスに注意
import CompanyService from "../Js/CompanyService";
import MyCommon from "../Js/MyCommon";

const myCommon = new MyCommon();

const routes: Array<RouteRecordRaw | any> = [
  { path: "/", component: () => import("../views/HomeView.vue") },
  { path: "/home", component: () => import("../views/HomeView.vue") },
  { path: "/authhome", component: () => import("../views/HomeView.vue") },
  {
    path: "/login",
    component: () => import("../views/HomeView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/ExternalLogins",
    beforeEnter() {
      window.location.href = `${
        import.meta.env.VITE_API_TARGET
      }/Identity/Account/ExternalLogin`;
    },
  },
  {
    path: "/Manage",
    beforeEnter() {
      window.location.replace(
        `${import.meta.env.VITE_API_TARGET}/Identity/Account/Manage`,
      );
    },
  },
  {
    path: "/counter",
    component: () => import("../views/CounterView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/fetch-data",
    component: () => import("../views/FetchDataView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/fileupload",
    component: () => import("../views/FileUploadView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pdf",
    component: () => import("../views/PDFView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myFullCalendar",
    component: () => import("../views/MyFullCalendarView.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/manegement",
    component: () => import("../views/MManegement.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/teikyoTaisei",
    component: () => import("../views/MTeikyoTaisei.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/teikyoTaiseiIryo",
    component: () => import("../views/MTeikyoTaiseiIryo.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/serviceTaniTanka",
    component: () => import("../views/MServiceTaniTanka.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/role",
    component: () => import("../views/RoleView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/userList",
    component: () => import("../views/MUserList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/user",
    component: () => import("../views/MUser.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/officeList",
    component: () => import("../views/MOfficeList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/staffList",
    component: () => import("../views/MStaffList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/shiftList",
    component: () => import("../views/MShiftList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/doctorList",
    component: () => import("../views/MDoctorList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/taisyoList",
    component: () => import("../views/MTaisyoList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/syohinList",
    component: () => import("../views/MSyohinList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/tani",
    component: () => import("../views/MTaniList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/tatemono",
    component: () => import("../views/MTatemomoList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/satellite",
    component: () => import("../views/MSatelliteList.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/shippei",
    component: () => import("../views/MUserShippei.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/syaryo",
    component: () => import("../views/MSyaryoList.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/soko",
    component: () => import("../views/MSokoList.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/location",
    component: () => import("../views/MLocationList.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/kyomikansin",
    component: () => import("../views/MKyomikansinList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/master/serviceCode",
    component: () => import("../views/MServiceCode.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/sogoService",
    component: () => import("../views/WSogoService.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/master/staff-role",
    component: () => import("../views/MStaffRole.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/about",
    component: () => import("../views/AboutView.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/userMemo",
    component: () => import("../views/Menu2/TUserMemo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/image",
    component: () => import("../views/Menu2/TUserImageManagement.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/careplanRenkeiImport",
    component: () => import("../views/Menu2/TCareplanRenkeiImport.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/serviceUsageTable",
    component: () => import("../views/Menu2/ServiceUsageTable.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/serviceUsageJissekiTable",
    component: () => import("../views/Menu2/ServiceUsageJissekiTable.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/serviceTeikyohyo",
    component: () => import("../views/Menu2/TServiceTeikyohyo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/serviceJissekihyo",
    component: () => import("../views/Menu2/TServiceJissekihyo.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/careplanRenkeiExport",
    component: () => import("../views/Menu2/TCareplanRenkeiExport.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/userUsage",
    component: () => import("../views/Menu2/TUserUsageCalender.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/userUsageList",
    component: () => import("../views/Menu2/Kaigo/TUserUsageList.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/userVitalSight",
    component: () => import("../views/Menu2/TUserVitalSight.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/homonKangoKirokusyo",
    component: () => import("../views/Menu2/THomonKangoKirokusyo1.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/homonKaigoKeikaku",
    component: () => import("../views/Menu2/Kaigo/THomonKaigoKeikaku.vue"),
    meta: { requiresAuth: true },
  }, // { path: '/homonKaigoKeikaku2', component: () => import('../views/Menu2/Kaigo/THomonKaigoKeikaku2.vue'), meta: { requiresAuth: true } },
  {
    path: "/tusyoKaigoKeikaku",
    component: () => import("../views/Menu2/TusyoKaigo/TTusyoKaigoKeikaku.vue"),
    meta: { requiresAuth: true },
  }, // { path: '/homonKaigoKeikaku2', component: () => import('../views/Menu2/Kaigo/THomonKaigoKeikaku2.vue'), meta: { requiresAuth: true } },
  {
    path: "/homonKangoKeikaku",
    component: () => import("../views/Menu2/Kango/THomonKangoKeikaku.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/homonKangoHokoku",
    component: () => import("../views/Menu2/Kango/THomonKangoHokoku.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/homonKangoHokoku2",
    component: () => import("../views/Menu2/Kango/THomonKangoHokoku2.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/homonKangoJohoTeikyo",
    component: () => import("../views/Menu2/THomonKangoJohoteikyo.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/kagakutekiKaigoHyoka",
    component: () => import("../views/Menu2/TKagakutekiKaigoHyoka.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/seikatuKinouCheck",
    component: () => import("../views/Menu2/TSeikatukinouCheck.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/kyomiKansinCheck",
    component: () => import("../views/Menu2/TKyomikansin.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/DBD13",
    component: () => import("../views/Menu2/TDbd13.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/icfStaging",
    component: () => import("../views/Menu2/TICFStging.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/seikatuNintikinou",
    component: () => import("../views/Menu2/TSeikatuNintikinou.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/kobetukinouKunren",
    component: () => import("../views/Menu2/TKobetukinouKeikaku.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/rihabiriKeikaku",
    component: () =>
      import("../views/Menu2/Rihabiri/TRihabiritationKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/eiyoscreening",
    component: () => import("../views/Menu2/TEiyoScreening.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/eiyoCareKeikaku",
    component: () => import("../views/Menu2/TEiyoCareKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/koukouEiseiKanri",
    component: () => import("../views/Menu2/TKoukouEiseiKanri.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/koukouKinouKeikaku",
    component: () => import("../views/Menu2/TKoukouKinouKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/jokusoKeikaku",
    component: () => import("../views/Menu2/TJokusoKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/haisetuKeikaku",
    component: () => import("../views/Menu2/THaisetuKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/jiritushienKeikaku",
    component: () => import("../views/Menu2/TJiritushienKeikaku.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/yakuzaiKanri",
    component: () => import("../views/Menu2/TYakuzaiKanri.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/adlKasan",
    component: () => import("../views/Menu2/TAdlKasan.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/life",
    component: () => import("../views/Menu2/TLife.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/visitingNurseRecordII",
    component: () => import("../views/VisitingNurseRecordII.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/visitingNursePlan",
    component: () => import("../views/VisitingNursePlan.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/visitingNurseReport",
    component: () => import("../views/VisitingNurseReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/userHutan",
    component: () => import("../views/Menu2/TUserHutanCalendar.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/staffShift",
    component: () => import("../views/Menu3/TStaffShift.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/staffMonthlySchedule",
    component: () => import("../views/Menu3/TStaffMonthlySchedule.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/userDaylySchedule",
    component: () => import("../views/Menu3/TUserDaylySchedule.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/staffDaylySchedule",
    component: () => import("../views/Menu3/TStaffDailySchedule.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/sougeiDaylySchedule",
    component: () => import("../views/Menu3/TSougeiDaylySchedule.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/workflow",
    component: () => import("../views/Menu3/TWorkFlow.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/myForm",
    component: () => import("../views/Menu3/TMyForm.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/workflow2",
    component: () => import("../views/Menu3/TWorkFlow2.vue"),
    meta: { requiresAuth: true },
  }, // eslint-disable-line
  {
    path: "/svgEditor",
    component: () => import("@/views/SvgEditorView.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/pdfManualUpload",
    component: () => import("@/views/Menu3/TManualUpload.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/meeting",
    component: () => import("@/views/Menu3/TMeeting.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/chat",
    component: () => import("../views/Menu3/TChat.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dicomImage",
    component: () => import("@/views/Menu2/TDicomImage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/seikyuInfo",
    component: () => import("@/views/Menu4/TSeikyuInfo.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/kokuhorenDenso",
    component: () => import("@/views/Menu4/TKokuhorenDenso.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/sogojigyokokuhorenDenso",
    component: () => import("@/views/Menu4/TSogojigyoKokuhorenDenso.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/kaigoKyuhuhiSeikyusyo",
    component: () => import("@/views/Menu4/TKaigoKyuhuhiSeikyusyo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/sogojigyouhiSeikyusyo",
    component: () => import("@/views/Menu4/TSogoJigyoSeikyusyo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/kaigoKyuhuhiMeisaisho",
    component: () => import("@/views/Menu4/TKaigoKyuhuhiMeisaisyo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/yoboKyuhuhiMeisaisho",
    component: () => import("@/views/Menu4/TYoboKyuhuhiMeisaisyo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/sogoJigyoMeisaisho",
    component: () => import("@/views/Menu4/TSogoJigyoMeisaisyo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/seikyuInfoIryo",
    component: () => import("@/views/Menu7/TSeikyuInfoIryo.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/kangoIryoSeikyuList",
    component: () => import("@/views/Menu7/TKangoIryoSeikyuList.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/shiire",
    component: () => import("@/views/Menu5/TShiireList.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/zaiko",
    component: () => import("@/views/Menu5/TZaikoList.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/syukko",
    component: () => import("@/views/Menu5/TSyukkoList.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/zaikoTable",
    component: () => import("@/views/Menu5/TZaikoTable.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/tanaoroshi",
    component: () => import("@/views/Menu5/TTanaoroshi.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/muserTable",
    component: () => import("@/views/Menu6/MUserTable.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/receiptScanner",
    component: () => import("@/components/ReceiptScanner.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/receiptScanner",
    component: () => import("@/components/ReceiptScanner.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/receiptScanner2",
    component: () => import("@/components/ReceiptScanner2.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/receiptScanner3",
    component: () => import("@/components/ReceiptScanner3.vue"),
    meta: {
      requiresAuth: true,
    }, // eslint-disable-line
  },

  {
    path: "/serviceRiyo",
    component: () => import("@/views/Menu2/TServiceRiyo.vue"),
    meta: {
      requiresAuth: true,
    }, // eslint-disable-line
  },

  {
    path: "/huggingFace",
    component: () => import("@/views/Menu3/THuggingFace.vue"),
    meta: {
      requiresAuth: true,
    }, // eslint-disable-line
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      //const response = await axios.get(`${import.meta.env.VITE_API_TARGET}/api/auth/isAuthenticated`, { withCredentials: true });
      const response = await CompanyService.fetchCompanyData();
      if (response === true) {
        if (
          myCommon.isNullOrEmpty(CompanyService.companyCode) ||
          myCommon.isNullOrEmpty(CompanyService.officeCode) ||
          myCommon.isNullOrEmpty(CompanyService.serviceType)
        ) {
          window.location.href = `${
            import.meta.env.VITE_API_TARGET
          }/Identity/Account/Manage/Index?returnUrl=${encodeURIComponent(
            to.fullPath,
          )}`;
        }

        store.dispatch("authenticate", true);
        next();
      } else {
        store.dispatch("authenticate", false);
        window.location.href = `${
          import.meta.env.VITE_API_TARGET
        }/Identity/Account/Login?returnUrl=${encodeURIComponent(to.fullPath)}`;
      }
    } catch (error) {
      console.error("Authentication check failed:", error);
      store.dispatch("authenticate", false);
      window.location.href = `${
        import.meta.env.VITE_API_TARGET
      }/Identity/Account/Login?returnUrl=${encodeURIComponent(to.fullPath)}`;
    }
  } else {
    next();
  }
});

// router.beforeEach(async (to, from, next) => {
//   if (to.meta.requiresAuth) {
//     const token = sessionStorage.getItem("token"); // ← JWT を取得

//     if (!token) {
//       // トークンがなければログインへリダイレクト
//       return (window.location.href = `${import.meta.env.VITE_API_TARGET}/Identity/Account/Login?returnUrl=${encodeURIComponent(to.fullPath)}`);
//     }

//     try {
//       // Axios にトークンを付与
//       const response = await axios.get(`${import.meta.env.VITE_API_TARGET}/api/GetCompanyInfo`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = response.data;

//       // 必須情報が足りなければマイページへ
//       if (!data.companyCode || !data.officeCode || !data.serviceType) {
//         return (window.location.href = `${import.meta.env.VITE_API_TARGET}/Identity/Account/Manage/Index?returnUrl=${encodeURIComponent(to.fullPath)}`);
//       }

//       await CompanyService.setCompanyData(data);

//       // // 情報保存
//       // sessionStorage.setItem('userName', data.userName);
//       // sessionStorage.setItem('companyCode', data.companyCode);
//       // sessionStorage.setItem('companyName', data.companyName);
//       // sessionStorage.setItem('officeCode', data.officeCode);
//       // sessionStorage.setItem('officeName', data.officeName);
//       // sessionStorage.setItem('serviceType', data.serviceType);

//       // ストアに反映
//       store.dispatch("authenticate", true);
//       next();
//     } catch (error) {
//       console.error("認証失敗:", error);
//       sessionStorage.removeItem("token");
//       store.dispatch("authenticate", false);
//       window.location.href = `${import.meta.env.VITE_API_TARGET}/Identity/Account/Login?returnUrl=${encodeURIComponent(to.fullPath)}`;
//     }
//   } else {
//     next(); // 認証不要なページはそのまま進む
//   }
// });

export default router;
